/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { People1EditIcon16Light } from './People1EditIcon16Light';
import { People1EditIcon16Regular } from './People1EditIcon16Regular';
import { People1EditIcon16Solid } from './People1EditIcon16Solid';
import { People1EditIcon20Light } from './People1EditIcon20Light';
import { People1EditIcon20Regular } from './People1EditIcon20Regular';
import { People1EditIcon20Solid } from './People1EditIcon20Solid';
import { People1EditIcon24Regular } from './People1EditIcon24Regular';
import { People1EditIcon24Solid } from './People1EditIcon24Solid';
import { People1EditIcon32Regular } from './People1EditIcon32Regular';
import { People1EditIcon64Regular } from './People1EditIcon64Regular';
var sizes = {
    16: {
        light: People1EditIcon16Light,
        regular: People1EditIcon16Regular,
        solid: People1EditIcon16Solid,
    },
    20: {
        light: People1EditIcon20Light,
        regular: People1EditIcon20Regular,
        solid: People1EditIcon20Solid,
    },
    24: {
        regular: People1EditIcon24Regular,
        solid: People1EditIcon24Solid,
    },
    32: {
        regular: People1EditIcon32Regular,
    },
    64: {
        regular: People1EditIcon64Regular,
    },
};
export var People1EditIcon = forwardRef('People1EditIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
